<template>
  <div class="searchDetails">
    <el-dialog
      title="搜索结果"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="1280px"
    >
      <div v-if="itemData" class="searchContent">
        <ul class="tab">
          <li
            v-for="(val,key,index) in listData"
            :key="index"
            :class="{active:key===activeKey}"
            @click="activeKey=key"
          >
            {{ val.name }}({{ val.list.total }})
          </li>
        </ul>
        <div v-loading.fullscreen.lock="loading" class="list">
          <div class="listContent">
            <template v-if="itemData.list&&itemData.list.data.length">
              <div
                v-for="(item, index) in itemData.list.data"
                :key="index"
                class="listItem"
                @click="handleRouteDto(item)"
              >
                <div class="itemTitle">
                  {{ item.name }}
                </div>
                <span class="item-date">
                  {{ item.create_date }}
                </span>
              </div>
            </template>
          </div>
          <div class="p-contianer">
            <el-pagination
              :current-page="itemData.list.current_page"
              :page-size.sync="contianer.page_size"
              :total="itemData.list.total"
              :pager-count="5"
              class="p-bar"
              background
              layout="prev, pager, next, total, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
      <div v-else class="NullData">
        <NullData />
      </div>
    </el-dialog>
    <div v-if="iframeDialogVisible">
      <el-dialog
        title="详情展示"
        :visible.sync="iframeDialogVisible"
        fullscreen
        :append-to-body="true"
      >
        <iframe :src="src" frameborder="0" width="100%" height="100%" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchAll } from '@/api/search'

import NullData from '@/components/NullData'
export default {
  //
  name: 'SearchDetails',
  components: {
    NullData
  },
  props: {
    parame: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: true,
      contianer: {
        page: 1,
        page_size: 20
      },
      listData: {},
      activeKey: '',
      type: '',
      search: '',
      loading: false,
      iframeDialogVisible: false,
      src: ''
    }
  },
  computed: {
    parameData() {
      return { search: this.search, type: this.type, ...this.contianer }
    },
    itemData() {
      return this.listData[this.activeKey] || null
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.$emit('hide')
      }
    }
  },
  created() {
    this.type = this.parame.type || ''
    this.search = this.parame.search || ''
    this.init()
  },
  mounted() {},
  methods: {
    // 首次取出总数据
    init() {
      searchAll(this.parameData).then((res) => {
        this.listData = res.data
        this.activeKey = Object.keys(this.listData)[0]
      })
    },
    getData() {
      searchAll(this.parameData).then((res) => {
        this.$set(this.listData, this.activeKey, res.data[this.activeKey])
        this.listData[this.activeKey]
      })
    },
    handleSizeChange(val) {
      this.contianer.page_size = val
      this.type = this.activeKey
      this.getData()
    },
    /**
     * 更改当前页数
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.contianer.page = val
      this.type = this.activeKey
      this.getData()
    },
    // 每次更改状态需要重新初始化参数,
    parameInit() {
      this.type = this.activeKey
    },
    handleRouteDto(item) {
      const path = {
        design: '/square/details',
        school_room: '/',
        wenku: '/notes/standard/details',
        information: '/information/details',
        guidance_announcement: '/notice/details',
        help: '/help/details'
      }[this.activeKey]
      if (this.activeKey !== 'school_room') {
        this.$router.push({ path, query: {
          id: item.id
        }})
        this.dialogVisible = false
      } else {
        this.src = item.vr_url
        this.iframeDialogVisible = true
        console.log(item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.NullData{
  width: 100%;
  height: 100%;
}
/deep/.el-dialog{
  background: #f6f6f6;
}
   /deep/ .el-dialog__body{
  height:700px;
  // min-height: 600px;
}

.searchContent{
  width: $xr-min-width;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  .tab{
    width: 100%;
    height:40px;
    display: flex;
    align-items: center;
    li{
      width: 200px;
      cursor: pointer;
    }
    .active{
      color: $xr-color-primary;
    }
  }
  .list{
    margin-top: 10px;
    padding: 20px;
    background: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }
  .listContent{
    width: 100%;
    height: 100%;
    overflow: auto;
    .listItem{
      height: 40px;
      border-bottom:1px solid #eee ;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #555;
      font-size: 16px;
      cursor: pointer;
      margin-bottom: 4px;
      .itemTitle{
         flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .item-date{
         width: 100px;
        flex-shrink: 0;
        margin-left: 25px;
      }
      &:hover{
         color: #2f82ff;
      }
    }
  }
}
</style>
